import { render } from "./TheTypeOfValue.vue?vue&type=template&id=fcd5333c&scoped=true&lang=html"
import script from "./TheTypeOfValue.vue?vue&type=script&lang=js"
export * from "./TheTypeOfValue.vue?vue&type=script&lang=js"

import "./TheTypeOfValue.vue?vue&type=style&index=0&id=fcd5333c&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fcd5333c"]])

export default __exports__